'use client';

import { useCallback, useEffect, useRef, useState } from 'react';
import { ModalPrimitive } from '@/shared/ui/Modal/Primitive';
import Portal from '@/shared/ui/Portal';
import { ModalContext } from './ModalContext';
import { ModalOptions } from './types';
interface ModalProviderProps {
  children: React.ReactNode;
}
export const ModalProvider: React.FC<ModalProviderProps> = ({
  children
}) => {
  const [modalState, setModalState] = useState<{
    isOpen: boolean;
    options?: ModalOptions;
  }>({
    isOpen: false,
    options: undefined
  });
  const open = useCallback((options?: ModalOptions) => {
    setModalState(prev => ({
      ...prev,
      isOpen: true,
      options
    }));
  }, []);
  const close = useCallback(() => {
    setModalState(prev_0 => ({
      ...prev_0,
      isOpen: false
    }));
  }, []);

  // keydown 리스너는 mount 시 1회만 등록 — close가 stable이라도 패턴 통일.
  const closeRef = useRef(close);
  closeRef.current = close;
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        closeRef.current();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
  return <ModalContext.Provider value={{
    open,
    close
  }}>
      {children}
      {modalState.isOpen && <Portal containerId="modal-root">
          <ModalPrimitive.Container onClickBackdrop={close}>
            {modalState.options?.modal}
          </ModalPrimitive.Container>
        </Portal>}
    </ModalContext.Provider>;
};